(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pepticool-plus-cart-toggle"] && !Shopify.designMode) return;
  try {
    (() => {
    const configElement = document.querySelector('[data-pepticool-plus-cart-config]');
    const template = document.querySelector('[data-pepticool-plus-cart-template]');
    if (!configElement || !template || window.pepticoolPlusCartToggleInitialized) return;
    window.pepticoolPlusCartToggleInitialized = true;

    const config = JSON.parse(configElement.textContent);
    const cartRoot = window.Shopify?.routes?.root || '/';
    const cartUrl = `${cartRoot}cart.js`;
    const addUrl = `${cartRoot}cart/add.js`;
    const changeUrl = `${cartRoot}cart/change.js`;
    let requestInFlight = null;
    let syncTimer = null;

    const parseResponse = async (response, requestPayload, requestUrl) => {
      const responseText = await response.text();
      let responsePayload = {};

      try {
        responsePayload = responseText ? JSON.parse(responseText) : {};
      } catch (parseError) {
        responsePayload = { raw: responseText };
      }

      if (!response.ok || responsePayload?.status) {
        const error = new Error(responsePayload?.description || responsePayload?.message || `Shopify request failed (${response.status})`);
        error.shopifyResponse = {
          status: response.status,
          requestUrl,
          requestPayload,
          response: responsePayload
        };
        throw error;
      }

      return responsePayload;
    };

    const requestJson = async (requestUrl, options = {}, requestPayload = null) => {
      const response = await fetch(requestUrl, options);
      return parseResponse(response, requestPayload, requestUrl);
    };

    const getCart = () => requestJson(cartUrl, {
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    });

    const findMembership = (cart) => Array.isArray(cart?.items) ? cart.items.find((item) => {
      const sameVariant = String(item.variant_id) === String(config.variantId);
      const samePlan = String(item.selling_plan_allocation?.selling_plan?.id || '') === String(config.sellingPlanId);
      return sameVariant && samePlan;
    }) : null;

    const updateToggleState = (cart) => {
      const row = document.querySelector('[data-pepticool-plus-cart-option]');
      const toggle = row?.querySelector('[data-pepticool-plus-cart-switch]');
      if (!toggle) return;
      toggle.checked = Boolean(findMembership(cart));
    };

    const refreshAtlasDrawer = (cart) => {
      document.dispatchEvent(new CustomEvent('atlas:cart-updated', {
        detail: { cart, source: 'pepticool-plus-cart-toggle', timestamp: Date.now() }
      }));
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pepticool-plus-cart-toggle' });
      }
    };

    const setError = (row, message = '') => {
      const errorElement = row?.querySelector('[data-pepticool-plus-cart-error]');
      if (!errorElement) return;
      errorElement.textContent = message;
      errorElement.hidden = !message;
    };

    const changeMembership = (shouldAdd, row) => {
      if (requestInFlight) return requestInFlight;

      requestInFlight = (async () => {
        row.classList.add('is-loading');
        const toggle = row.querySelector('[data-pepticool-plus-cart-switch]');
        toggle.disabled = true;
        setError(row);

        const currentCart = await getCart();
        const existingMembership = findMembership(currentCart);

        if (shouldAdd && !existingMembership) {
          const addPayload = {
            items: [{
              id: Number(config.variantId),
              quantity: 1,
              selling_plan: Number(config.sellingPlanId)
            }]
          };
          await requestJson(addUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(addPayload)
          }, addPayload);
        } else if (shouldAdd && Number(existingMembership?.quantity) !== 1) {
          const changePayload = { id: existingMembership.key, quantity: 1 };
          await requestJson(changeUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(changePayload)
          }, changePayload);
        } else if (!shouldAdd && existingMembership) {
          const changePayload = { id: existingMembership.key, quantity: 0 };
          await requestJson(changeUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(changePayload)
          }, changePayload);
        }

        const updatedCart = await getCart();
        const membership = findMembership(updatedCart);
        if (shouldAdd && (!membership || Number(membership.quantity) !== 1)) {
          throw new Error(config.addError);
        }
        if (!shouldAdd && membership) {
          throw new Error(config.removeError);
        }

        updateToggleState(updatedCart);
        refreshAtlasDrawer(updatedCart);
        return updatedCart;
      })().catch((error) => {
        console.error('PeptiCool+ cart drawer toggle failed:', error?.shopifyResponse || error);
        setError(row, error?.message || (shouldAdd ? config.addError : config.removeError));
        return getCart().then((cart) => {
          updateToggleState(cart);
          return cart;
        });
      }).finally(() => {
        row?.classList.remove('is-loading');
        const toggle = row?.querySelector('[data-pepticool-plus-cart-switch]');
        if (toggle) toggle.disabled = false;
        requestInFlight = null;
      });

      return requestInFlight;
    };

    const injectToggle = () => {
      const footer = document.querySelector('#atlas-upsell-cart-drawer-main-container .atlas-upsell-cart-footer');
      if (!footer) return null;

      let row = footer.querySelector('[data-pepticool-plus-cart-option]');
      if (!row) {
        row = template.content.firstElementChild.cloneNode(true);
        const warranty = footer.querySelector('.atlas-upsell-cart-shipping-protection-container');
        footer.insertBefore(row, warranty || footer.firstElementChild);

        row.querySelector('[data-pepticool-plus-cart-switch]')?.addEventListener('change', (event) => {
          changeMembership(event.currentTarget.checked, row);
        });
      }

      return row;
    };

    const syncToggle = () => {
      const row = injectToggle();
      if (!row || requestInFlight) return;
      getCart().then(updateToggleState).catch((error) => {
        console.error('PeptiCool+ cart drawer state check failed:', error?.shopifyResponse || error);
      });
    };

    const scheduleSync = () => {
      window.clearTimeout(syncTimer);
      syncTimer = window.setTimeout(syncToggle, 60);
    };

    const observer = new MutationObserver(() => {
      const drawer = document.querySelector('#atlas-upsell-cart-drawer-main-container');
      if (drawer && !drawer.querySelector('[data-pepticool-plus-cart-option]')) scheduleSync();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('atlas:cart-updated', scheduleSync);
    document.addEventListener('cart:add', scheduleSync);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleSync, { once: true });
    } else {
      scheduleSync();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
